import { fetchServices, fetchRebook, removeSer, fetchListHotel } from '@/api/service'
import { fetchPaxsGroup } from '@/api/passenger'

const getSelectManualService = (context) => {
  fetchServices().then((response) => {
    context.commit('SELECTMANUALSERVICE_UPDATED', _.keyBy(response, 'service_id'))
  })
}
const getRebook = (context) => {
  fetchRebook().then((response) => {
    context.commit('REBOOK_GET', response)
  })
}

const removeService = (context, payload) => {
  return removeSer(payload).then((response) => {
    return response
  })
}

const getPaxsGroup = (context) => {
  fetchPaxsGroup().then((response) => {
    context.commit('PAXS_GROUP', response)
  })
}

export default {
  getSelectManualService,
  getRebook,
  removeService,
  getPaxsGroup
}
